import { ACTION_EDIT, configuratorAction, configuratorStep, internalBrands, studioItemType } from './constants';
import {
  CANVAS_OVER_VIGNETTE_MIN_WIDTH,
  ProcessTypes,
  UNDERSCORE,
  WEBUSER_CS_GUEST,
  logoEditingStatusEnum,
  previewType,
  vendorId as vendorIdDict,
} from '../utils/constants';
import {
  checkAllowMultipleArts,
  checkIsLaserProduct,
  checkNeedValidateInterval,
  checkNeedVectorImage,
} from '../utils/processTypeUtil';

import { DEFAULT_VIGNETTE_SIZE } from '../nextgen/constants';
import { ThumbnailType } from '../bom/constants';
import { createSelector } from 'reselect';
import { getConfiguratorAction } from './logics';
import { getFinalBomOptionsSelectionForUpsellItem } from '../upsell/logics';
import { getStockImageUrlByExistenceMode } from '../utils/scene7url';
import { getTexturizedStockImageUrl } from '../utils/scene7url';
import { vendorId } from '../utils/constants';

export const getItemUseScene7Template = (state) => {
  return state.specs.newFxg ? false : true;
};

export const getCartUseScene7Template = (state) => {
  if (state.ui.cartUseScene7Template === undefined) return true;
  else return state.ui.cartUseScene7Template ? true : false;
};

export const getItemName = (state) => {
  return state.specs.name;
};

export const getIsImprintRequired = (state) => {
  return state.specs.isImprintRequired;
};

export const getShowHorizontalRuler = (state) => {
  return state.specs.showHorizontalRuler;
};

export const getShowVerticalRuler = (state) => {
  return state.specs.showVerticalRuler;
};

export const getWaitingCoverProps = (state) => {
  return state.ui.waitingCover;
};

export const getTransparencyCoverProps = (state) => {
  return state.ui.transparencyCover;
};

export const getMessageBoxProps = (state) => {
  return state.ui.messageBox;
};

export const getConfirmDialogProps = (state) => {
  return state.ui.confirmDialog;
};

export const getUploadProgress = createSelector(
  (state) => state.ui.waitingCover.percent,
  (state) => state.ui.waitingCover.text,
  (percent, text) => ({ percent, text })
);

export const getLogoEditingStatus = (state) => {
  return state.ui && state.ui.logoEditingStatus
    ? state.ui.logoEditingStatus
    : { currentStatus: logoEditingStatusEnum.None };
};

export const getCurrentLogoEditingStatus = (state) => {
  return state.ui && state.ui.logoEditingStatus ? state.ui.logoEditingStatus.currentStatus : logoEditingStatusEnum.None;
};

export const getCanvasRefreshFlag = (state) => {
  return state.ui && state.ui.canvasStatus ? state.ui.canvasStatus.refreshFlag : null;
};

//
export const getItemId = (state) => {
  return state.specs.itemId;
};

export const getItemSku = (state) => {
  return state.specs.displayItemSku;
};

export const getStudioItemType = createSelector(
  (state) => state.specs,
  (specs) => specs.studioItemType
);

export const getZipCode = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.zip
);

export const getCoupon = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.coupon
);

export const getToken = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.token
);

export const getReturnUrl = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.returnUrl
);

export const getPriceSvcUrl = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.priceSvcUrl
);

export const getVendorId = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.vendorId
);

export const getStatus = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.status
);

export const getRefId = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.refId
);

export const getSample = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.sample
);

export const getDisplayItemSku = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.displayItemSku
);

export const getSessionId = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.sessionId
);

export const getScid = createSelector(
  (state) => state.parameters,
  (parameters) => (parameters['scid'] || '').trim()
);

export const getRepId = createSelector(
  (state) => state.parameters,
  (parameters) => {
    return Object.keys(parameters).includes('rep') ? parameters['rep'] : '';
  }
);

export const getCustomerServiceNumber = createSelector(
  (state) => state.vendor,
  (vendor) => vendor.csNumber
);

export const getDetailInfo = createSelector(
  (state) => state.detailInfo,
  (detailInfo) => detailInfo
);
export const getProductColor = createSelector(
  (state) => state.uniqueOptionsBackup,
  (uniqueOptionsBackup) => {
    const filteredItems = [];

    for (const key in uniqueOptionsBackup) {
      if (key !== 'INC' && key !== 'CYR') {
        const filteredArray = uniqueOptionsBackup[key].filter(
          (item) => item.colorReference && !item.description.includes('Other')
        );
        if (filteredArray.length > 0) {
          filteredItems.push(...filteredArray);
        }
      }
    }

    // return filteredItems.slice(0, 30);
    return filteredItems;
  }
);

export const getCurrentModal = createSelector(
  (state) => state.ui.currentModal,
  (currentModal) => currentModal
);

export const getCompany = createSelector(
  (state) => state.vendor,
  (vendor) => (vendor.company || '').trim()
);

export const getCompanyName = createSelector(
  (state) => state.vendor,
  (vendor) => vendor.companyName
);

export const getDivision = createSelector(
  (state) => state.vendor,
  (vendor) => (vendor.division || '').trim()
);
export const getAllowEmailSignUp = createSelector(
  (state) => state.vendor,
  (vendor) => vendor.allowEmailSignUp
);
export const getAllowSaveProject = createSelector(
  (state) => state.vendor,
  (vendor) => vendor.allowSaveforLater
);
export const isShowCancelButton = createSelector(
  (state) => state.vendor,
  (vendor) => vendor.showCancelButton
);

export const getActiveCartTotalCount = createSelector(
  (state) => state.activeCart,
  (activeCart) => (activeCart && activeCart.totalCartItems ? activeCart.totalCartItems : 0)
);
export const getActiveCartOrderTotal = createSelector(
  (state) => state.activeCart,
  (activeCart) => (activeCart && activeCart.orderTotal ? activeCart.orderTotal : 0)
);

export const getTotalSaveProjectCount = createSelector(
  (state) => state.activeCart,
  (activeCart) => (activeCart && activeCart.totalSaveProjectItems ? activeCart.totalSaveProjectItems : 0)
);
export const getTotalWishListCount = createSelector(
  (state) => state.activeCart,
  (activeCart) => (activeCart && activeCart.totalWishListItems ? activeCart.totalWishListItems : 0)
);
export const getCurrentStep = createSelector(
  (state) => state.ui.step,
  (step) => step
);
export const getSelectedUpsells = createSelector(
  (state) => state.upsells,
  (state) => state.ui.optionalUpsellsExcluded,
  (upsells, optionalUpsellsExcluded) => {
    let selectedUpsells = [];
    for (let upsell of upsells) {
      if (optionalUpsellsExcluded && !upsell.item.isRequired) continue;
      if (upsell.isSelected && upsell.totalQuantity > 0) {
        let textDict = {};
        if (upsell.textDict !== null) {
          for (let key of Object.keys(upsell.textDict)) {
            let textDataList = [];
            if (upsell.textDict[key] !== undefined) {
              upsell.textDict[key].forEach((text) => {
                let textData = Object.assign({}, text.data);
                textData.studioItemType = upsell.item.studioItemType;
                textDataList.push(textData);
              });
              textDict[key] = textDataList;
            }
          }
        }
        let imageDict = null;
        if (upsell.imageDict !== null) {
          imageDict = {};
          for (let key of Object.keys(upsell.imageDict)) {
            let imageDataList = [];
            if (upsell.imageDict[key] !== undefined) {
              upsell.imageDict[key].forEach((image) => {
                let imageData = Object.assign({}, image);
                imageData.studioItemType = upsell.item.studioItemType;
                imageDataList.push(imageData);
              });
              imageDict[key] = imageDataList;
            }
          }
        }
        selectedUpsells.push({
          itemId: upsell.item.itemId,
          totalQuantity: upsell.totalQuantity,
          bomOption: getFinalBomOptionsSelectionForUpsellItem(upsell),
          text: textDict,
          image: imageDict,
          imprintAreas: upsell.imprintAreas,
          logoLocationCode: upsell.logoLocationCode,
          imprintLocationCode: upsell.imprintLocationCode,
          scale: upsell.scaleDict,
        });
      }
    }
    return selectedUpsells;
  }
);

export const getWebAddress = createSelector(
  (state) => state.vendor,
  (vendor) => vendor.webAddress
);

export const getTrackingPixelScript = (state) => state.trackingPixelScript;

export const getUserFullName = (state) =>
  state.user != null
    ? state.user.middleInitial && state.user.middleInitial !== ''
      ? `${state.user.firstName} ${state.user.middleInitial} ${state.user.lastName}`
      : `${state.user.firstName} ${state.user.lastName}`
    : '';
export const getUserEmail = (state) => (state.user ? state.user.email : '');
export const getUserCustomerNumber = (state) => (state.user ? state.user.customerNumber : '');
export const getUserCompanyName = (state) => (state.user ? state.user.companyName : '');
export const getUser = (state) => state.user;
export const getGreeting = createSelector(
  (state) => state.user,
  (user) => {
    let greeting = WEBUSER_CS_GUEST;
    if (user) {
      if (user.companyName && user.companyName.length > 0) greeting = user.companyName;
      else {
        const fullName = user.middleInitial
          ? `${user.firstName} ${user.middleInitial} ${user.lastName}`
          : `${user.firstName} ${user.lastName}`;
        if (fullName.trim()) greeting = fullName;
        else greeting = user.customerNumber;
      }
    }
    return greeting;
  }
);

export const getHasCustomUploadedLogos = createSelector(
  (state) => state.user,
  (user) => {
    return user && Object.keys(user).includes('hasCustomUploadedLogos') ? user['hasCustomUploadedLogos'] : false;
  }
);

export const getEmailSignUpStatus = createSelector(
  (state) => state.user,
  (user) => (user ? user.isEmailSignUp : false)
);

export const getCurrentImprintAreaKey = createSelector(
  (state) => state.ui.currentImprintAreaKey,
  (currentImprintAreaKey) => currentImprintAreaKey
);

/**
 * remove the selector?
 */
// export const getCurrentCanvasKey = createSelector(getCurrentImprintAreaKey, (currentImprintAreaKey) => {
//   let keys = currentImprintAreaKey.split('-');
//   if (keys.length === 3) {
//     return keys[0] + '-' + keys[1];
//   } else {
//     return currentImprintAreaKey;
//   }
// });
export const getCurrentImprintAreaCode = createSelector(getCurrentImprintAreaKey, (currentImprintAreaKey) => {
  let keys = currentImprintAreaKey.split('-');
  if (keys.length === 3) {
    return keys[0];
  } else {
    return currentImprintAreaKey;
  }
});

export const getCurrentImprintProcessType = createSelector(
  (state) => state.imprintAreaDict,
  (state, currentKey) => currentKey || getCurrentImprintAreaKey(state),
  (imprintAreaDict, currentKey) =>
    currentKey && imprintAreaDict[currentKey] ? imprintAreaDict[currentKey].processType : null
);

export const getIsLaserProduct = createSelector(
  (state) => state.imprintAreaDict,
  (state, currentKey) => currentKey || getCurrentImprintAreaKey(state),
  (imprintAreaDict, currentKey) => {
    let processType = currentKey && imprintAreaDict[currentKey] ? imprintAreaDict[currentKey].processType : null;
    if (!processType) {
      return false;
    }

    return checkIsLaserProduct(processType);
  }
);

export const getAllowMultipleArts = createSelector(
  (state) => state.imprintAreaDict,
  getStudioItemType,
  (state, currentKey) => currentKey || getCurrentImprintAreaKey(state),
  (imprintAreaDict, itemType, currentKey) => {
    if (itemType === studioItemType.digital) return true;

    let processType = currentKey && imprintAreaDict[currentKey] ? imprintAreaDict[currentKey].processType : null;
    if (!processType) {
      return false;
    }

    return checkAllowMultipleArts(processType);
  }
);

export const getNeedValidateInterval = createSelector(
  (state) => state.imprintAreaDict,
  (state, currentKey) => currentKey || getCurrentImprintAreaKey(state),
  (imprintAreaDict, currentKey) => {
    let processType = currentKey && imprintAreaDict[currentKey] ? imprintAreaDict[currentKey].processType : null;
    if (!processType) {
      return false;
    }

    return checkNeedValidateInterval(processType);
  }
);

export const getNeedVectorImage = createSelector(
  (state) => state.imprintAreaDict,
  (state, currentKey) => currentKey || getCurrentImprintAreaKey(state),
  (imprintAreaDict, currentKey) => {
    let processType = currentKey && imprintAreaDict[currentKey] ? imprintAreaDict[currentKey].processType : null;
    if (!processType) {
      return false;
    }

    return checkNeedVectorImage(processType);
  }
);

export const getCurrentHotStampedCheck = createSelector(
  getCurrentImprintProcessType,
  (processType) => processType === ProcessTypes.HotStamped || processType === ProcessTypes.FoilFusing
);

export const getCurrentDebossCheck = createSelector(
  getCurrentImprintProcessType,
  (processType) => processType === ProcessTypes.Deboss
);

export const getRootDir = createSelector(
  (state) => state.vendor,
  (vendor) => vendor.rootDir
);
export const getProp65Message = (state) => state.specs.prop65Message;
export const getProp65MessageShowOneOff = (state) => state.ui.prop65MessageOneOff;
export const getParameters = createSelector(
  (state) => state.parameters,
  (parameters) => parameters
);

export const hasPreviewShow = createSelector(
  getCurrentImprintAreaKey,
  (state) => state.ui.fullPreviewDict,
  (currentImprintAreaKey, fullPreviewDict) => {
    if (fullPreviewDict !== undefined && fullPreviewDict !== null) {
      let fullPreviews = fullPreviewDict[currentImprintAreaKey];
      if (fullPreviews === undefined) {
        return false;
      } else {
        if (fullPreviews.length === 0) {
          // if fullPreviews.length === 0, then there is no vignette preview
          return false;
        } else {
          return true;
        }
      }
    }
  }
);

const BOM_PREVIEW_DIMENSION = '&$Studio_VignetteThumb$';
export const getBomQuestionPreviewFactory = (questionId, bomOption, thumbnailWidth) => {
  return createSelector(
    (state) => state.ui.bomPreview,
    (bomPreview) => {
      let url = '';
      if (
        ((bomPreview.questionPreview !== undefined && Object.keys(bomPreview.questionPreview).length > 0) ||
          (bomPreview.defaultPreview !== null && bomPreview.defaultPreview !== undefined)) &&
        bomOption
      ) {
        let questionPreview = null;
        if (bomPreview.questionPreview[questionId] !== undefined) {
          questionPreview = bomPreview.questionPreview[questionId];
        } else questionPreview = bomPreview.defaultPreview;
        //let bomColorCode = questionPreview.placeHolder.bomColorCode;
        let leftPlaceHolder = questionPreview.placeHolder.leftPlaceHolder;
        let rightPlaceHolder = questionPreview.placeHolder.rightPlaceHolder;
        let placeHolder = leftPlaceHolder + bomOption.code + rightPlaceHolder;
        let color = '';
        let texturePlaceHolder = '';
        const placeHolderDict = questionPreview.placeHolder.bomColorCode[bomOption.code];
        if (bomOption.useTexture) {
          color = bomOption.code + UNDERSCORE + bomOption.codeValue;
          if (placeHolderDict) {
            texturePlaceHolder = placeHolderDict.textureUrl.url;
          }
        } else {
          color = bomOption.colorReference.replace('#', '');
          if (placeHolderDict) {
            texturePlaceHolder = placeHolderDict.nonTextureUrl.url;
          }
        }
        url = questionPreview.url.replace(placeHolder, texturePlaceHolder).replace(placeHolder, color);
        if (thumbnailWidth === undefined) url += BOM_PREVIEW_DIMENSION;
        else url += '&wid=' + thumbnailWidth + '&hei=' + thumbnailWidth;
      }
      return url;
    }
  );
};

export const getUpsellBomPreviewFactory = (questionId, thumbnailWidth) => {
  return createSelector(getCurrentUpsell, (currentUpsell) => {
    let url = '';
    let bomPreview = currentUpsell.bomPreview;
    if (
      (bomPreview.questionPreview !== undefined && Object.keys(bomPreview.questionPreview).length > 0) ||
      (bomPreview.defaultPreview !== null && bomPreview.defaultPreview !== undefined)
    ) {
      let questionPreview = null;
      if (bomPreview.questionPreview[questionId] !== undefined) {
        questionPreview = bomPreview.questionPreview[questionId];
      } else questionPreview = bomPreview.defaultPreview;
      url = questionPreview.url;
      if (thumbnailWidth === undefined) url += BOM_PREVIEW_DIMENSION;
      else url += '&wid=' + thumbnailWidth + '&hei=' + thumbnailWidth;
    }
    return url;
  });
};

export const getBomDefaultPreviewFactory = (bomOptions) => {
  return createSelector(
    (state) => state.ui.bomPreview,
    (bomPreview) => {
      let url = '';
      if (bomPreview.defaultPreview !== undefined && bomPreview.defaultPreview !== null) {
        let defaultPreview = bomPreview.defaultPreview;
        let bomColorCode = defaultPreview.placeHolder.bomColorCode;
        let leftPlaceHolder = defaultPreview.placeHolder.leftPlaceHolder;
        let rightPlaceHolder = defaultPreview.placeHolder.rightPlaceHolder;
        url = defaultPreview.url;
        let texturePlaceHolder = '';
        Object.keys(bomColorCode).forEach((key) => {
          const code = key;
          let placeHolder = leftPlaceHolder + code + rightPlaceHolder;
          let bomOption = bomOptions.find((o) => o.code === code);
          let color = '';
          if (bomOption !== undefined) {
            if (bomOption.useTexture) {
              color = bomOption.code + UNDERSCORE + bomOption.codeValue;
              texturePlaceHolder = bomColorCode[key].textureUrl.url;
            } else {
              color = bomOption.colorReference.replace('#', '');
              texturePlaceHolder = bomColorCode[key].nonTextureUrl.url;
            }
            url = url.replace(placeHolder, texturePlaceHolder).replace(placeHolder, color);
          }
        });
      }
      return url;
    }
  );
};

export const getBomPreview = (state) => state.ui.bomPreview;

export const getProductType = createSelector(
  (state) => state.specs,
  (specs) => {
    return Object.keys(specs).includes('typeName') ? specs['typeName'] : '';
  }
);

export const getColorCode = createSelector(
  (state) => state.ui.fullPreviewDict,
  (state) => state.questions,
  getCurrentImprintAreaKey,
  (fullPreviewDict, questions, currentImprintAreaKey) => {
    let codes = [];
    let hasVignetteUrl =
      fullPreviewDict[currentImprintAreaKey] &&
      fullPreviewDict[currentImprintAreaKey].find((x) => x.type === previewType.Vignette);
    if (hasVignetteUrl) {
      let keys = Object.keys(fullPreviewDict);
      for (let key of keys) {
        let fullPreviews = fullPreviewDict[key];
        for (let fullPreview of fullPreviews) {
          const bomColorCodes = Object.keys(fullPreview.placeHolder.bomColorCode);
          for (let code of bomColorCodes) {
            if (codes.indexOf(code) === -1) codes.push(code);
          }
        }
      }
      console.log('codes');
      console.log(codes);
    } else {
      const colorQuestions = questions.filter(
        (x) => x.thumbnailType === ThumbnailType.COLOR_SWATCH || x.thumbnailType === ThumbnailType.SCENE7_IMAGE
      );
      if (colorQuestions && colorQuestions.length > 0) {
        colorQuestions.forEach((colorQuestion) => {
          codes.push(colorQuestion.code);
        });
      }
    }
    return codes;
  }
);

export const getBomPreviewColorCode = createSelector(
  (state) => state.ui.bomPreview,
  (bomPreview) => {
    let codes = [];
    if (
      bomPreview !== null &&
      bomPreview !== undefined &&
      bomPreview.defaultPreview !== undefined &&
      bomPreview.defaultPreview !== null
    ) {
      codes = Object.keys(bomPreview.defaultPreview.placeHolder.bomColorCode);
    }
    return codes;
  }
);

export const getLoadedImprintAreaKeys = createSelector(
  (state) => state.ui.loadedImprintAreaKeys,
  (loadedImprintAreaKeys) => loadedImprintAreaKeys
);

export const getShowAssortedColorsHelp = createSelector(
  (state) => state.specs,
  (specs) => specs.showAssortedColorsHelp
);

export const getFullPackageQuantity = createSelector(
  (state) => state.specs,
  (specs) => {
    return Object.keys(specs).includes('fullPackageQuantity') ? specs['fullPackageQuantity'] : 0;
  }
);

export const getTempBackgroundImage = createSelector(
  (state) => state.ui.tempBackgroundImage,
  (tempBackgroundImage) => tempBackgroundImage
);

export const getTempBackgroundImageOrigin = createSelector(
  (state) => state.ui.tempBackgroundImage && state.ui.tempBackgroundImage.origin,
  (tempBackgroundImageOrigin) => tempBackgroundImageOrigin
);

export const getElementDragFlag = createSelector(
  (state) => state.ui.elementDragFlag,
  (elementDragFlag) => elementDragFlag
);

export const getBatchSelectFlagForTouch = createSelector(
  (state) => state.ui.batchSelectFlagForTouch,
  (batchSelectFlagForTouch) => batchSelectFlagForTouch
);

export const getTokenWarningShow = createSelector(
  (state) => state.ui.showTokenWarning,
  (showTokenWarning) => showTokenWarning
);

export const getTokenExpirationShow = createSelector(
  (state) => state.ui.showTokenExpiration,
  (showTokenExpiration) => showTokenExpiration
);

export const getSaveProject = createSelector(
  (state) => state.saveProject,
  (saveProject) => saveProject
);

export const getInitializedImprintAreaKeys = createSelector(
  (state) => state.ui.initializedImprintAreaKeys,
  (initializedImprintAreaKeys) => initializedImprintAreaKeys
);

export const getCharges = createSelector(
  (state) => state.charges,
  (charges) => charges
);

export const getShowViewPricingPanel = createSelector(
  (state) => state.ui.showViewPricingPanel,
  (showViewPricingPanel) => showViewPricingPanel
);
export const getVendor = createSelector(
  (state) => state.vendor,
  (vendor) => vendor
);
export const getIsNavinkPlug = createSelector(
  (state) => state.parameters,
  (parameters) => parameters.returnUrl && parameters.returnUrl.toLowerCase() === 'up'
);
export const isInternalBrand = (state) => {
  return internalBrands.indexOf(state.parameters.vendorId) > -1;
};
export const getBeforeUnloadListening = createSelector(
  (state) => state.ui.beforeUnloadListening,
  (beforeUnloadListening) => beforeUnloadListening
);
export const getCanAddToCart = createSelector(
  (state) => state.vendor,
  (vendor) => vendor && vendor.canAddToCart
);

export const getCurrentUpsellsValidationStatus = createSelector(
  (state) => state.ui,
  (ui) =>
    Object.keys(ui).includes('currentUpsellsValidationStatus')
      ? ui['currentUpsellsValidationStatus']
      : { invalidItemId: '', showMessageBox: false }
);

export const getOrder = createSelector(
  (state) => state.order,
  (order) => order
);

export const isSuperUser = createSelector(
  (state) => state.parameters,
  (parameters) => {
    const rep = parameters.rep;
    return rep && rep.length > 0;
  }
);

export const getIsAdminEditReorder = createSelector(
  (state) => state.parameters,
  (state) => state.order,
  isSuperUser,
  (parameters, order, isSuperUser) => {
    const action = parameters.status;
    return (
      action &&
      action.toLowerCase() === ACTION_EDIT &&
      isSuperUser &&
      order &&
      order.orderId &&
      order.orderId.length > 0
    );
  }
);
export const getAdminToolsHost = createSelector(
  (state) => state.vendor,
  (vendor) => vendor.adminToolsAddress
);
export const getShipping = createSelector(
  (state) => state.shipping,
  (shipping) => shipping
);

export const getCurrentImprintOptionStep = createSelector(
  (state) => state.ui,
  (ui) => ui.currentImprintOptionStep
);
export const getSidebarTabKey = createSelector(
  (state) => state.ui,
  (ui) => ui.currentSidebarTabKey
);
export const getTextEditingStatus = createSelector(
  (state) => state.ui,
  (ui) => ui.textEditingStatus
);
export const getSelectedTextColor = createSelector(
  (state, currentImprintAreaKey) => state.textDict[currentImprintAreaKey],
  (state, currentImprintAreaKey) => state.ui.imprintOption[currentImprintAreaKey],
  (texts, imprintOption) => {
    if (texts && texts.length > 0 && texts[0].data && texts[0].data.color) {
      return texts[0].data.color;
    } else {
      return imprintOption && imprintOption.textColor;
    }
  }
);

export const getCurrentTextColor = createSelector(
  (state, currentImprintAreaKey) => state.textDict[currentImprintAreaKey],
  (texts) => {
    if (texts && texts.length > 0 && texts[0].data && texts[0].data.color) {
      return texts[0].data.color;
    }
  }
);

export const getTemplateId = (state) => state.parameters.templateId;
export const getCurrentImprintAreaDimension = createSelector(
  getCurrentImprintAreaKey,
  (state) => state.ui.imprintAreaDimension,
  (currentImprintAreaKey, imprintAreaDimension) => {
    return imprintAreaDimension && imprintAreaDimension[currentImprintAreaKey];
  }
);
export const getImprintAreaDimension = createSelector(
  (state) => state.ui,
  (ui) => ui.imprintAreaDimension
);
export const getCurrentUpsellItemId = createSelector(
  (state) => state.ui,
  (ui) => ui.currentUpsellItemId
);

export const getCurrentUpsell = createSelector(
  getCurrentUpsellItemId,
  (state) => state.upsells,
  (currentUpsellItemId, upsells) => {
    return upsells.find((x) => x.item.itemId === currentUpsellItemId);
  }
);
export const getHasUpsells = (state) => state.specs.hasUpsells;

export const getCurrentParentChildOptionEditingInfo = createSelector(
  (state) => state.ui,
  (ui) =>
    Object.keys(ui).includes('currentParentChildOptionEditingInfo')
      ? ui['currentParentChildOptionEditingInfo']
      : { isEditing: false, parentOption: null, parentQuestion: null }
);

export const getCurrentGuideModeCheck = createSelector(
  (state) => state.ui.guideMode,
  getCurrentImprintAreaKey,
  (currentGuideMode, currentImprintAreaKey) => {
    const isGuideMode = currentGuideMode.hasOwnProperty(currentImprintAreaKey)
      ? currentGuideMode[currentImprintAreaKey]
      : false;
    return isGuideMode;
  }
);

export const getHasLogoFile = createSelector(
  (state) => state.vendor,
  (vendor) => vendor.hasLogoFile
);

export const getIsAllowDesignLater = createSelector(
  getStatus,
  (state) => state.specs.isDesignLater,
  (action, isDesignLater) => {
    const currentAction = getConfiguratorAction(action);
    const allowDesignLater =
      currentAction === configuratorAction.designLater || (currentAction === configuratorAction.edit && isDesignLater);
    return allowDesignLater;
  }
);

export const getCurrentUpsellType = createSelector(
  (state) => state.ui,
  (ui) => ui.currentUpsellType
);

export const getCurrentActiveCommonTemplate = createSelector(
  (state) => state.ui,
  (ui) => (Object.keys(ui).includes('currentActiveCommonTemplate') ? ui['currentActiveCommonTemplate'] : null)
);

export const getCurrentBackgroundDesignPanelShownFlag = createSelector(
  getCurrentImprintAreaKey,
  (state) => state.ui.backgroundDesignPanelShownFlags,
  (imprintAreaKey, flags) => (Object.keys(flags).includes(imprintAreaKey) ? flags[imprintAreaKey] : false)
);

//TODO: yjli, Will converge MandatorySlogan into ImprintArea store, Backend api change first
export const getSloganMandatoryCheck = createSelector(
  (state, imprintAreaCode) => imprintAreaCode || getCurrentImprintAreaCode(state),
  (state) => state.sloganDict,
  (imprintAreaCode, sloganDict) => {
    let isMandatory = false;
    if (sloganDict[imprintAreaCode] && sloganDict[imprintAreaCode].slogans) {
      isMandatory = sloganDict[imprintAreaCode].slogans.every((x) => x.sloganReference.toUpperCase() !== 'NONE');
    }
    return isMandatory;
  }
);
export const getTopPaddingHeightOfImprintView = createSelector(
  (state) => state.ui,
  (ui) => ui.setTopPaddingHeightOfImprintView
);

export const getSaveProjectData = createSelector(
  (state) => state.ui,
  (ui) => ui.saveProjectData
);
export const getShowSizeChartForMobileLite = createSelector(
  (state) => state.ui,
  (ui) => (Object.keys(ui).includes('showSizeChartForMobileLite') ? ui['showSizeChartForMobileLite'] : false)
);

export const getNeedImprintOptionModeCheck = createSelector(
  (state) => state.ui.needImprintOptionMode,
  (state, currentImprintAreaKey) => currentImprintAreaKey || getCurrentImprintAreaKey(state),
  (currentNeedImprintOptionMode, currentImprintAreaKey) => {
    const isNeedImprintOptionMode = currentNeedImprintOptionMode[currentImprintAreaKey] || false;
    return isNeedImprintOptionMode;
  }
);

export const getCurrentAskNeedImprintOptionInfo = (state) => state.ui.currentAskNeedImprintOptionInfo;

export const getAllDataLoadedForLite = createSelector(
  (state) => state.ui,
  (ui) => (Object.keys(ui).includes('allDataLoadedForLite') ? ui['allDataLoadedForLite'] : false)
);

export const getTwinItemId = (state) => {
  return state.specs.twinItemId;
};

export const getStockImageTypeDict = (state) => {
  return state.ui.stockImageTypeDict;
};

export const getIsRegisterForEmailUpdates = (state) => {
  return state.ui.registerForEmailUpdates;
};
export const getStockImageUrlForBom = createSelector(
  getItemId,
  getTwinItemId,
  getStockImageTypeDict,
  (_, bomOption) => bomOption,
  (itemId, twinItemId, stockImageTypeDict, bomOption) => {
    let url = getStockImageUrlByExistenceMode(itemId, twinItemId, stockImageTypeDict, bomOption, false);
    if (!!url) url += BOM_PREVIEW_DIMENSION;
    return url;
  }
);

export const getTexturizedImageName = createSelector(
  getItemId,
  getTwinItemId,
  (_, bomOption) => bomOption,
  (itemId, twinItemId, bomOption) => {
    let url = '';
    if (bomOption.useTexture) {
      const _itemId = twinItemId || itemId;
      url = `texture_${_itemId}_${bomOption.code}_${bomOption.codeValue}`;
    }
    return url;
  }
);

export const getTexturizedImageUrl = createSelector(
  (state, bomOption) => getTexturizedImageName(state, bomOption),
  (_, bomOption) => bomOption,
  (textureImageName, bomOption) => {
    const url = bomOption.useTexture ? getTexturizedStockImageUrl(textureImageName) : '';
    return url;
  }
);

export const getTecSysItemFlag = createSelector(
  (state) => state.specs,
  (specs) => (Object.keys(specs).includes('isTecSysItem') ? specs['isTecSysItem'] : false)
);

export const getShowPreviewAboveCanvas = createSelector(
  (state) => state.imprintAreaDict,
  (state) => state.specs.showPreviewAboveCanvas,
  getCurrentImprintAreaKey,
  (imprintAreaDict, showPreviewAboveCanvas, currentImprintAreaKey) => {
    return currentImprintAreaKey && imprintAreaDict[currentImprintAreaKey]
      ? imprintAreaDict[currentImprintAreaKey].isShowPreviewAboveCanvas && showPreviewAboveCanvas
      : false;
  }
);

export const getIfCurrentBrandNeedsToRecalculatePrice = createSelector(
  getCurrentStep,
  getVendorId,
  (currentStep, vendorId) => {
    return currentStep !== configuratorStep.shipping && internalBrands.includes(vendorId);
  }
);
export const getWarningMessage = createSelector(
  (state) => state.ui.warningMessage,
  (warningMessage) => warningMessage
);
export const showRedWarningBox = createSelector(
  getWarningMessage,
  (_, labelArray) => labelArray,
  (warningMessage, labelArray) => {
    const { show, message } = warningMessage;
    return show && message.some((messageItem) => labelArray.some((label) => messageItem.indexOf(label) !== -1));
  }
);

export const getExternalWaitingCoverId = (state) => state.ui.externalWaitingCoverId;

export const getReturnUrlValidity = createSelector(
  (state) => state.ui,
  (ui) => ui.isValidReturnUrl
);

export const getCanvasOverVignetteConfig = createSelector(
  (state) => state.imprintAreaDict,
  getCurrentImprintAreaKey,
  (imprintAreaDict, currentImprintAreaKey) => {
    return currentImprintAreaKey && imprintAreaDict[currentImprintAreaKey]
      ? {
          canvasX: imprintAreaDict[currentImprintAreaKey].canvasX,
          canvasY: imprintAreaDict[currentImprintAreaKey].canvasY,
          direction: imprintAreaDict[currentImprintAreaKey].direction,
          showBackgroundColor: imprintAreaDict[currentImprintAreaKey].showBackgroundColor,
          canvasWidth:
            imprintAreaDict[currentImprintAreaKey].canvasWidth <= 0
              ? 0
              : Math.max(CANVAS_OVER_VIGNETTE_MIN_WIDTH, imprintAreaDict[currentImprintAreaKey].canvasWidth),
          vignette: imprintAreaDict[currentImprintAreaKey].vignette,
          defaultVignetteWidth: imprintAreaDict[currentImprintAreaKey].defaultVignetteWidth || DEFAULT_VIGNETTE_SIZE,
          defaultVignetteHeight: imprintAreaDict[currentImprintAreaKey].defaultVignetteHeight || DEFAULT_VIGNETTE_SIZE,
        }
      : null;
  }
);

export const getOfflineChatBoxStep = createSelector(
  (state) => state.offlineChat,
  (offlineChat) => offlineChat.step
);

export const getOfflineChatBoxError = createSelector(
  (state) => state.offlineChat,
  (offlineChat) => offlineChat.errorMessage
);

export const getOfflineChatLoading = createSelector(
  (state) => state.offlineChat,
  (offlineChat) => offlineChat.loading
);

export const getIsAplOrCanBranch = createSelector(
  getVendorId,
  (vendorId) => Number(vendorId) === vendorIdDict.Amsterdam || Number(vendorId) === vendorIdDict.AmsterdamProducts
);

export const isAllowPreselectBom = createSelector(
  (state) => state.specs,
  (specs) => specs.allowPreselectBom
);

export const getItemImprintAreaCode = createSelector(
  (state) => state.specs,
  (specs) => (Object.keys(specs).includes('imprintAreaCode') ? specs['imprintAreaCode'].trim() : '')
);

export const getImprintAreaDict = createSelector(
  (state) => state.imprintAreaDict,
  (imprintAreaDict) => imprintAreaDict
);

export const getSpecialChargeDetail = createSelector(
  (state) => state.charges,
  (state, isCondition) => isCondition,
  (charges, isCondition) => {
    return charges.filter(
      (charge) =>
        charge.chargeType === 'M' ||
        (isCondition
          ? charge.chargeConditionNumber === 8 || charge.chargeConditionNumber === 16
          : charge.chargeConditionNumber === 3 ||
            charge.chargeConditionNumber === 6 ||
            charge.chargeConditionNumber === 8 ||
            charge.chargeConditionNumber === 16)
    );
  }
);

export const getWhetherIsForGooglePLA = createSelector(
  getCompany,
  getDivision,
  getScid,
  getCoupon,
  (company, division, scid, couponCode) => {
    const coupon = (couponCode || '').trim().toUpperCase();
    return (
      (company.toUpperCase() === 'APL' &&
        division.toUpperCase() === 'APL' &&
        scid.toUpperCase() === 'PSPIA6107' &&
        (coupon === 'AA958' || coupon === 'DK895')) ||
      (company.toUpperCase() === 'CAN' &&
        division.toUpperCase() === 'CAN' &&
        scid.toUpperCase() === 'PSRKG8900' &&
        coupon === 'BP561')
    );
  }
);

export const getWhetherItemHasClickableColorSwatches = createSelector(
  (state) => state.specs,
  (specs) => !!specs.clickableColorSwatches
);

export const getItemSkuForDisplay = createSelector(getDisplayItemSku, getItemId, (displayItemSku, itemId) =>
  !!displayItemSku ? displayItemSku : itemId
);

export const getSpecialSpellingWords = createSelector(getVendorId, (currentVendorId) => {
  const canadianVendorIds = [vendorId.AmsterdamProducts, vendorId.WindmillCanada];
  const isCanadianSite = canadianVendorIds.includes(parseInt(currentVendorId, 10));

  const catalog = isCanadianSite ? 'Catalogue' : 'Catalog';
  const color = isCanadianSite ? 'Colour' : 'Color';
  const state = isCanadianSite ? 'Province' : 'State/Territory';
  const zipCode = isCanadianSite ? 'Postal Code' : 'Zip Code';

  return {
    catalog,
    color,
    state,
    zipCode,
  };
});
